<div
  class="radio-group"
  [attr.data-orientation]="orientation"
  [attr.multiSelectable]="multiSelectable"
  [attr.data-disabled]="disabled"
>
  <ng-content></ng-content>
</div>
